import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { $utils } from '@/common/helper'

Vue.use(VueI18n)

const files1 = require.context('.', true, /\.js$/)
const files2 = require.context('../../../common/locales', true, /\.js$/)

const customUS = {}
const customGL = {}
const customJP = {}
const customCF = {}
const customCA = {}
const customCN = {}
const customRU = {}

const locale = {}

files1.keys().forEach((key) => {
  if (key === './index.js') return
  Object.assign(customUS, files1(key).default.US)
  Object.assign(customGL, files1(key).default.GL)
  Object.assign(customJP, files1(key).default.JP)
  Object.assign(customCF, files1(key).default.CF)
  Object.assign(customCA, files1(key).default.CA)
  Object.assign(customCN, files1(key).default.CN)
  Object.assign(customRU, files1(key).default.RU)
})
files2.keys().forEach((key) => {
  if (key === './index.js') return
  Object.assign(customUS, files2(key).default.US)
  Object.assign(customGL, files2(key).default.GL)
  Object.assign(customJP, files2(key).default.JP)
  Object.assign(customCF, files2(key).default.CF)
  Object.assign(customCA, files2(key).default.CA)
  Object.assign(customCN, files2(key).default.CN)
  Object.assign(customRU, files2(key).default.RU)
})

function addLang (key, a, b) {
  locale[key] = Object.assign(a, b)
}
addLang('US', customUS, {})
addLang('GL', customGL, {})
addLang('JP', customJP, {})
addLang('CF', customCF, {})
addLang('CA', customCA, {})
addLang('CN', customCN, {})
addLang('RU', customRU, {})

/* inject i18n */
const lang = $utils.getCountryCode()

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || lang,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'GL',
  messages: locale
})

// export default locale
